import axios from "axios";
import { takeLatest, call, put, select, all } from "redux-saga/effects";
import { createAction } from "redux-actions";
import { queryParams } from "../../../../../../utils/queryParams.js";
import moment from "moment";

export const SET_LOADING = "saga/SET_LOADING";
export const SET_UPDATES_LOADING = "saga/SET_UPDATES_LOADING";
export const SET_FILTERS_DIRTY = "saga/SET_FILTERS_DIRTY";
export const SET_TABLE_DATA_LOADING = "saga/SET_TABLE_DATA_LOADING";
export const FETCH_CURRENT_USER = "saga/FETCH_CURRENT_USER";
export const FETCH_CURRENT_USER_SUCCESS = "saga/FETCH_CURRENT_USER_SUCCESS";
export const FETCH_CURRENT_USER_FAILURE = "saga/FETCH_CURRENT_USER_FAILURE";
export const FETCH_CHART = "saga/FETCH_CHART";
export const FETCH_CHART_SUCCESS = "saga/FETCH_CHART_SUCCESS";
export const FETCH_CHART_FAILURE = "saga/FETCH_CHART_FAILURE";
export const FETCH_GRAPH = "saga/FETCH_GRAPH";
export const FETCH_GRAPH_SUCCESS = "saga/FETCH_GRAPH_SUCCESS";
export const FETCH_GRAPH_FAILURE = "saga/FETCH_GRAPH_FAILURE";
export const FETCH_TABLE_DATA = "saga/FETCH_TABLE_DATA";
export const FETCH_TABLE_DATA_SUCCESS = "saga/FETCH_TABLE_DATA_SUCCESS";
export const FETCH_TABLE_DATA_FAILURE = "saga/FETCH_TABLE_DATA_FAILURE";
export const FETCH_FILTERS = "saga/FETCH_FILTERS";
export const FETCH_FILTERS_SUCCESS = "saga/FETCH_FILTERS_SUCCESS";
export const FETCH_FILTERS_FAILURE = "saga/FETCH_FILTERS_FAILURE";
export const CHANGE_TOGGLE = "sagas/CHANGE_TOGGLE";
export const CHANGE_TOGGLE_SUCCESS = "sagas/CHANGE_TOGGLE_SUCCESS";

export const UPDATE_FILTERS = "saga/UPDATE_FILTERS";
export const UPDATE_FILTERS_SUCCESS = "saga/UPDATE_FILTERS_SUCCESS";
export const UPDATE_FILTERS_FAILURE = "saga/UPDATE_FILTERS_FAILURE";
export const UPDATE_FILTERS_BY_STAFF = "saga/UPDATE_FILTERS_BY_STAFF";
export const UPDATE_FILTERS_BY_STAFF_SUCCESS = "saga/UPDATE_FILTERS_BY_STAFF_SUCCESS";
export const UPDATE_FILTERS_BY_STAFF_FAILURE = "saga/UPDATE_FILTERS_BY_STAFF_FAILURE";
export const UPDATE_FILTERS_BY_CLASS = "saga/UPDATE_FILTERS_BY_CLASS";
export const UPDATE_FILTERS_BY_CLASS_SUCCESS = "saga/UPDATE_FILTERS_BY_CLASS_SUCCESS";
export const UPDATE_FILTERS_BY_CLASS_FAILURE = "saga/UPDATE_FILTERS_BY_CLASS_FAILURE";
export const RESET_CATEGORY_FILTER = "saga/RESET_CATEGORY_FILTER";
export const SET_CLASS_FILTERS_LOADING = "saga/SET_CLASS_FILTERS_LOADING";
export const SET_STAFF_FILTERS_LOADING = "saga/SET_STAFF_FILTERS_LOADING";
export const SET_CUSTOM_DATE_RANGE_LOADING = "saga/SET_CUSTOM_DATE_RANGE_LOADING";
export const SET_PRIMARY_FILTER = "saga/SET_PRIMARY_FILTER";

export const UPDATE_CLASS_FILTERS = "saga/UPDATE_CLASS_FILTERS";
export const UPDATE_STAFF_FILTERS = "saga/UPDATE_STAFF_FILTERS";
export const UPDATE_CHART = "saga/UPDATE_CHART";
export const UPDATE_CHART_SUCCESS = "saga/UPDATE_CHART_SUCCESS";
export const UPDATE_CHART_FAILURE = "saga/UPDATE_CHART_FAILURE";
export const UPDATE_DATA_BY_STAFF = "saga/UPDATE_DATA_BY_STAFF";
export const UPDATE_DATA_BY_CLASS = "saga/UPDATE_DATA_BY_CLASS";
export const UPDATE_CATEGORY_FILTER = "saga/UPDATE_CATEGORY_FILTER";

export const SET_DATES = "saga/SET_DATES";
export const UPDATE_DATES = "saga/UPDATE_DATES";
export const RESET_TABLE_DATA = "sagas/RESET_TABLE_DATA";
export const UPDATE_CUSTOM_RANGE = "sagas/UPDATE_CUSTOM_RANGE";
export const UPDATE_PERIOD_TYPE = "sagas/UPDATE_PERIOD_TYPE";
export const UPDATE_PERIOD_TYPE_SELECTED = "sagas/UPDATE_PERIOD_TYPE_SELECTED";
export const YEAR_OVER_YEAR_LOADING = "sagas/YEAR_OVER_YEAR_LOADING";
export const UPDATE_TYPE_FILTER = "sagas/UPDATE_TYPE_FILTER";
export const UPDATE_TYPE_FILTER_SELECTED = "sagas/UPDATE_TYPE_FILTER_SELECTED";
export const RESET_TYPE_FILTER_SELECTED = "sagas/RESET_TYPE_FILTER_SELECTED";

export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  getTableData: createAction(FETCH_TABLE_DATA),
  updateClasses: createAction(UPDATE_CLASS_FILTERS),
  updateCategory: createAction(UPDATE_CATEGORY_FILTER),
  updateStaff: createAction(UPDATE_STAFF_FILTERS),
  updateData: createAction(UPDATE_CHART),
  updateDates: createAction(UPDATE_DATES),
  updateCustomRange: createAction(UPDATE_CUSTOM_RANGE),
  updateDataByStaff: createAction(UPDATE_DATA_BY_STAFF),
  updateDataByClass: createAction(UPDATE_DATA_BY_CLASS),
  updatePeriodType: createAction(UPDATE_PERIOD_TYPE),
  updateType: createAction(UPDATE_TYPE_FILTER),
  onChangeToggle: createAction(CHANGE_TOGGLE)
};
export default function* watchUtilization() {
  yield takeLatest(FETCH_CURRENT_USER, getCurrentUserData);
  yield takeLatest(FETCH_TABLE_DATA, fetchModalTableData);
  yield takeLatest(UPDATE_CHART, updateData);
  yield takeLatest(UPDATE_DATA_BY_STAFF, updateDataByStaff);
  yield takeLatest(UPDATE_DATA_BY_CLASS, updateDataByClass);
  yield takeLatest(UPDATE_CUSTOM_RANGE, updateCustomRange);
  yield takeLatest(UPDATE_DATES, updateDates);
  yield takeLatest(UPDATE_PERIOD_TYPE, updatePeriodTypeAndLoad);
  yield takeLatest(UPDATE_TYPE_FILTER, updateTypeAndLoad);
  yield takeLatest(CHANGE_TOGGLE, onChangeToggle);
}

export function getIds(data) {
  let ids = "";
  data.map((item) => {
    ids = ids + item.id + ",";
  });
  return ids;
}

export function getTypeOption(data) {
  if (data === "Physical") {
    return "y";
  } else if (data === "Virtual") {
    return "n";
  } else {
    return "y,n";
  }
}

export function* updateClasses(payload) {
  yield put({ type: UPDATE_CLASS_FILTERS, payload: payload });
}

export function* updateCategory(payload) {
  yield put({ type: UPDATE_CATEGORY_FILTER, payload: payload });
}

export function* updateTypeAndLoad(payload) {
  yield put({ type: UPDATE_TYPE_FILTER_SELECTED, payload: payload.payload });
  yield put({ type: SET_CLASS_FILTERS_LOADING, payload: true });
  yield put({ type: SET_STAFF_FILTERS_LOADING, payload: true });

  const allSagas = [fetchFilters()];
  try {
    yield all(allSagas);
    yield put({ type: SET_CLASS_FILTERS_LOADING, payload: false });
    yield put({ type: SET_STAFF_FILTERS_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

export function* updateStaff(payload) {
  yield put({ type: UPDATE_STAFF_FILTERS, payload: payload });
}

export function* updatePeriodTypeAndLoad(payload) {
  yield put({ type: UPDATE_PERIOD_TYPE_SELECTED, payload: payload.payload });
  yield put({ type: YEAR_OVER_YEAR_LOADING, payload: true });
  const allSagas = [fetchUpdateGraph()];
  try {
    yield all(allSagas);
    yield put({ type: YEAR_OVER_YEAR_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

export function* updateCustomRange() {
  yield put({ type: SET_CLASS_FILTERS_LOADING, payload: true });
  yield put({ type: SET_STAFF_FILTERS_LOADING, payload: true });

  const allSagas = [fetchFilters()];
  try {
    yield all(allSagas);
    yield put({ type: SET_CLASS_FILTERS_LOADING, payload: false });
    yield put({ type: SET_STAFF_FILTERS_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

export function* updateDataByStaff(payload) {
  const primaryFilter = yield select((state) => state.utilization.primaryFilter);
  const filters = yield select((state) => state.utilization.filters);

  if ((filters.staff_values.length !== payload.payload.length) & (primaryFilter !== "class")) {
    yield put({ type: UPDATE_STAFF_FILTERS, payload: payload.payload });
    yield put({ type: SET_CLASS_FILTERS_LOADING, payload: true });
    yield put({ type: SET_PRIMARY_FILTER, payload: "staff" });
    const allSagas = [updateFiltersByStaff()];
    try {
      yield all(allSagas);
      yield put({ type: SET_CLASS_FILTERS_LOADING, payload: false });
    } catch (error) {
      console.error(error);
    }
  } else if (
    (filters.staff_values.length === payload.payload.length) &
    (primaryFilter === "staff")
  ) {
    yield put({ type: SET_PRIMARY_FILTER, payload: "" });
    yield put({ type: SET_CLASS_FILTERS_LOADING, payload: true });
    yield put({ type: UPDATE_STAFF_FILTERS, payload: payload.payload });
    const allSagas = [updateFiltersByStaff()];
    try {
      yield all(allSagas);
      yield put({ type: SET_CLASS_FILTERS_LOADING, payload: false });
    } catch (error) {
      console.error(error);
    }
  } else {
    yield put({ type: UPDATE_STAFF_FILTERS, payload: payload.payload });
  }
}

export function* updateDataByClass(payload) {
  const primaryFilter = yield select((state) => state.utilization.primaryFilter);
  const filters = yield select((state) => state.utilization.filters);

  if ((filters.class_values.length !== payload.payload.length) & (primaryFilter !== "staff")) {
    yield put({ type: UPDATE_CLASS_FILTERS, payload: payload.payload });
    yield put({ type: SET_STAFF_FILTERS_LOADING, payload: true });
    yield put({ type: SET_PRIMARY_FILTER, payload: "class" });
    const allSagas = [updateFiltersByClass()];
    try {
      yield all(allSagas);
      yield put({ type: SET_STAFF_FILTERS_LOADING, payload: false });
    } catch (error) {
      console.error(error);
    }
  } else if (
    (filters.class_values.length === payload.payload.length) &
    (primaryFilter === "class")
  ) {
    yield put({ type: SET_PRIMARY_FILTER, payload: "" });
    yield put({ type: SET_STAFF_FILTERS_LOADING, payload: true });
    yield put({ type: UPDATE_CLASS_FILTERS, payload: payload.payload });
    const allSagas = [updateFiltersByClass()];
    try {
      yield all(allSagas);
      yield put({ type: SET_STAFF_FILTERS_LOADING, payload: false });
    } catch (error) {
      console.error(error);
    }
  } else {
    yield put({ type: UPDATE_CLASS_FILTERS, payload: payload.payload });
  }
}

export function* updateDates() {
  yield put({ type: SET_CLASS_FILTERS_LOADING, payload: true });
  yield put({ type: SET_STAFF_FILTERS_LOADING, payload: true });
  yield put({ type: SET_CUSTOM_DATE_RANGE_LOADING, payload: true });

  const allSagas = [fetchFilters()];
  try {
    yield all(allSagas);
    yield put({ type: SET_CLASS_FILTERS_LOADING, payload: false });
    yield put({ type: SET_STAFF_FILTERS_LOADING, payload: false });
    yield put({ type: SET_CUSTOM_DATE_RANGE_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

export function* updateChart() {
  // const datesDirty = yield select((state) => state.utilization.datesDirty);
  const allSagas = [fetchUpdateChart(), fetchUpdateGraph()];
  // if (datesDirty) {
  //   allSagas.push(updateFilters());
  // }
  try {
    yield put({ type: SET_FILTERS_DIRTY, payload: false });
    yield all(allSagas);
  } catch (error) {
    console.error(error);
  }
}

export function* getCurrentUserData(data) {
  yield put({
    type: FETCH_CURRENT_USER_SUCCESS,
    payload: { currentUser: data.payload.currentUser, numberOfMonths: data.payload.numberOfMonths }
  });
  yield put({ type: SET_LOADING, payload: true });
  yield put({ type: SET_FILTERS_DIRTY, payload: false });
  yield put({
    type: RESET_CATEGORY_FILTER,
    payload: {
      id: 1,
      name: "Utilization"
    }
  });
  yield put({ type: RESET_TYPE_FILTER_SELECTED, payload: { id: 2, name: "Physical" } });
  const endDate = yield select((state) => state.utilization.currentUser.calendarEndDate);
  yield put({
    type: SET_DATES,
    payload: {
      startDate: moment(endDate).startOf("month").format("YYYY-MM-DD"),
      endDate: endDate
    }
  });

  try {
    yield call(fetchChart);
    yield call(fetchFilters);
    yield call(fetchGraph);
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

export function* updateData() {
  const datesDirty = yield select((state) => state.utilization.datesDirty);
  yield put({ type: SET_UPDATES_LOADING, payload: true });
  const allSagas = [updateChart()];
  if (datesDirty) {
    allSagas.push(updateFilters());
  }
  try {
    yield all(allSagas);
    yield put({ type: SET_UPDATES_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

export function* fetchChart() {
  const endDate = yield select((state) => state.utilization.currentUser.calendarEndDate);
  const startDate = yield select((state) => state.utilization.selectedRequestDates.startDate);
  const id = yield select((state) => state.utilization.currentUser.organization_id);
  const objectId = yield select((state) => state.utilization.currentUser.current_object_id);
  const locationId = yield select((state) => state.utilization.currentUser.current_location_id);
  const regionId = yield select((state) => state.utilization.currentUser.current_region_id);
  const currentCategory = yield select((state) => state.utilization.selectedCategoryFilters.name);
  const currentType = getTypeOption(
    yield select((state) => state.utilization.selectedTypeOption.name)
  );
  try {
    const response = yield call(
      axios.post,
      queryParams.apiVersion + "pages/attendance/utilization_chart/utilization_heatmap",
      {
        organization_id: id.toString(),
        location_id: locationId.toString(),
        region_id: regionId.toString(),
        object_id: objectId.toString(),
        category_type: currentCategory.toString(),
        offline: currentType.toString(),
        start_date: startDate,
        end_date: endDate
      }
    );

    yield put({ type: FETCH_CHART_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_CHART_FAILURE, error });
  }
}

export function* fetchGraph() {
  const endDate = yield select((state) => state.utilization.currentUser.calendarEndDate);
  const startDate = yield select((state) => state.utilization.selectedRequestDates.startDate);
  const id = yield select((state) => state.utilization.currentUser.organization_id);
  const objectId = yield select((state) => state.utilization.currentUser.current_object_id);
  const locationId = yield select((state) => state.utilization.currentUser.current_location_id);
  const regionId = yield select((state) => state.utilization.currentUser.current_region_id);
  const periodType = yield select((state) => state.utilization.periodType);
  const currentCategory = yield select((state) => state.utilization.selectedCategoryFilters.name);
  const { selectedStaffFilters, selectedClassFilters } = yield select((state) => state.utilization);
  const currentType = getTypeOption(
    yield select((state) => state.utilization.selectedTypeOption.name)
  );
  try {
    const response = yield call(
      axios.post,
      queryParams.apiVersion + "pages/attendance/utilization_chart/utilization_chart",
      {
        organization_id: id.toString(),
        location_id: locationId.toString(),
        region_id: regionId.toString(),
        object_id: objectId.toString(),
        period_type: periodType.toLowerCase().toString(),
        category_type: currentCategory.toString(),
        offline: currentType.toString(),
        start_date: startDate,
        end_date: endDate,
        staff_id: getIds(selectedStaffFilters),
        class_id: getIds(selectedClassFilters)
      }
    );
    yield put({ type: FETCH_GRAPH_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_GRAPH_FAILURE, error });
  }
}

export function* fetchUpdateGraph() {
  const endDate = yield select((state) => state.utilization.selectedRequestDates.endDate);
  const startDate = yield select((state) => state.utilization.selectedRequestDates.startDate);
  const id = yield select((state) => state.utilization.currentUser.organization_id);
  const objectId = yield select((state) => state.utilization.currentUser.current_object_id);
  const locationId = yield select((state) => state.utilization.currentUser.current_location_id);
  const regionId = yield select((state) => state.utilization.currentUser.current_region_id);
  const classFilters = yield select((state) => state.utilization.selectedClassFilters);
  const staffFilters = yield select((state) => state.utilization.selectedStaffFilters);
  const periodType = yield select((state) => state.utilization.periodType);
  const currentCategory = yield select((state) => state.utilization.selectedCategoryFilters.name);
  const currentType = getTypeOption(
    yield select((state) => state.utilization.selectedTypeOption.name)
  );
  try {
    const response = yield call(
      axios.post,
      queryParams.apiVersion + "pages/attendance/utilization_chart/utilization_chart",
      {
        organization_id: id.toString(),
        location_id: locationId.toString(),
        region_id: regionId.toString(),
        object_id: objectId.toString(),
        period_type: periodType.toLowerCase().toString(),
        offline: currentType.toString(),
        start_date: startDate,
        end_date: endDate,
        class_id: getIds(classFilters),
        staff_id: getIds(staffFilters),
        category_type: currentCategory.toString()
      }
    );
    yield put({ type: FETCH_GRAPH_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_GRAPH_FAILURE, error });
  }
}

export function* fetchUpdateChart() {
  const { startDate, endDate } = yield select((state) => state.utilization.selectedRequestDates);

  const {
    organization_id: id,
    current_object_id: objectId,
    current_location_id: locationId,
    current_region_id: regionId
  } = yield select((state) => state.utilization.currentUser);

  const classFilters = yield select((state) => state.utilization.selectedClassFilters);
  const staffFilters = yield select((state) => state.utilization.selectedStaffFilters);
  const currentCategory = yield select((state) => state.utilization.selectedCategoryFilters.name);
  const groupByWeekDay = yield select((state) => state.utilization.groupByWeekDay);
  const currentType = getTypeOption(
    yield select((state) => state.utilization.selectedTypeOption.name)
  );
  try {
    const response = yield call(
      axios.post,
      queryParams.apiVersion + "pages/attendance/utilization_chart/utilization_heatmap",
      {
        organization_id: id.toString(),
        location_id: locationId.toString(),
        region_id: regionId.toString(),
        object_id: objectId.toString(),
        offline: currentType.toString(),
        start_date: startDate,
        end_date: endDate,
        class_id: getIds(classFilters),
        staff_id: getIds(staffFilters),
        category_type: currentCategory.toString(),
        group_by_week_day: groupByWeekDay
      }
    );
    yield put({ type: UPDATE_CHART_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: UPDATE_CHART_FAILURE, error });
  }
}

export function* fetchModalTableData(payload) {
  yield put({ type: SET_TABLE_DATA_LOADING, payload: true });
  const startDate = yield select((state) => state.utilization.selectedRequestDates.startDate);
  const endDate = yield select((state) => state.utilization.selectedRequestDates.endDate);
  const id = yield select((state) => state.utilization.currentUser.organization_id);
  const objectId = yield select((state) => state.utilization.currentUser.current_object_id);
  const locationId = yield select((state) => state.utilization.currentUser.current_location_id);
  const regionId = yield select((state) => state.utilization.currentUser.current_region_id);
  const currentType = getTypeOption(
    yield select((state) => state.utilization.selectedTypeOption.name)
  );
  const currentCategory = yield select((state) => state.utilization.selectedCategoryFilters.name);

  try {
    const response = yield call(
      axios.post,
      queryParams.apiVersion + "pages/attendance/utilization_chart/classes_info",
      {
        organization_id: id.toString(),
        location_id: locationId.toString(),
        region_id: regionId.toString(),
        object_id: objectId.toString(),
        tableDataUid: payload.payload.tableDataUid,
        offline: currentType.toString(),
        start_date: startDate,
        end_date: endDate,
        current_category: currentCategory
      }
    );
    yield put({ type: FETCH_TABLE_DATA_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_TABLE_DATA_FAILURE, error });
  }
}

export function* fetchFilters() {
  const startDate = yield select((state) => state.utilization.selectedRequestDates.startDate);
  const endDate = yield select((state) => state.utilization.selectedRequestDates.endDate);
  const id = yield select((state) => state.utilization.currentUser.organization_id);
  const objectId = yield select((state) => state.utilization.currentUser.current_object_id);
  const locationId = yield select((state) => state.utilization.currentUser.current_location_id);
  const regionId = yield select((state) => state.utilization.currentUser.current_region_id);
  const currentType = getTypeOption(
    yield select((state) => state.utilization.selectedTypeOption.name)
  );
  try {
    const response = yield call(
      axios.post,
      queryParams.apiVersion + "pages/attendance/utilization_chart/get_filters",
      {
        organization_id: id.toString(),
        location_id: locationId.toString(),
        region_id: regionId.toString(),
        object_id: objectId.toString(),
        offline: currentType.toString(),
        start_date: startDate,
        end_date: endDate
      }
    );
    yield put({ type: FETCH_FILTERS_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_FILTERS_FAILURE, error });
  }
}

export function* updateFilters() {
  const startDate = yield select((state) => state.utilization.selectedRequestDates.startDate);
  const endDate = yield select((state) => state.utilization.selectedRequestDates.endDate);
  const id = yield select((state) => state.utilization.currentUser.organization_id);
  const objectId = yield select((state) => state.utilization.currentUser.current_object_id);
  const locationId = yield select((state) => state.utilization.currentUser.current_location_id);
  const regionId = yield select((state) => state.utilization.currentUser.current_region_id);
  const classFilters = yield select((state) => state.utilization.selectedClassFilters);
  const staffFilters = yield select((state) => state.utilization.selectedStaffFilters);
  const currentType = getTypeOption(
    yield select((state) => state.utilization.selectedTypeOption.name)
  );
  try {
    const response = yield call(
      axios.post,
      queryParams.apiVersion + "pages/attendance/utilization_chart/get_filters",
      {
        organization_id: id.toString(),
        location_id: locationId.toString(),
        region_id: regionId.toString(),
        object_id: objectId.toString(),
        offline: currentType.toString(),
        start_date: startDate,
        end_date: endDate,
        class_id: getIds(classFilters),
        staff_id: getIds(staffFilters)
      }
    );
    yield put({ type: UPDATE_FILTERS_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: UPDATE_FILTERS_FAILURE, error });
  }
}

export function* updateFiltersByStaff() {
  const startDate = yield select((state) => state.utilization.selectedRequestDates.startDate);
  const endDate = yield select((state) => state.utilization.selectedRequestDates.endDate);
  const id = yield select((state) => state.utilization.currentUser.organization_id);
  const objectId = yield select((state) => state.utilization.currentUser.current_object_id);
  const locationId = yield select((state) => state.utilization.currentUser.current_location_id);
  const regionId = yield select((state) => state.utilization.currentUser.current_region_id);
  const staffFilters = yield select((state) => state.utilization.selectedStaffFilters);
  const currentType = getTypeOption(
    yield select((state) => state.utilization.selectedTypeOption.name)
  );
  try {
    const response = yield call(
      axios.post,
      queryParams.apiVersion + "pages/attendance/utilization_chart/get_filters",
      {
        organization_id: id.toString(),
        location_id: locationId.toString(),
        region_id: regionId.toString(),
        object_id: objectId.toString(),
        offline: currentType.toString(),
        start_date: startDate,
        end_date: endDate,
        staff_id: getIds(staffFilters)
      }
    );
    yield put({ type: UPDATE_FILTERS_BY_STAFF_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: UPDATE_FILTERS_BY_STAFF_SUCCESS, error });
  }
}

export function* updateFiltersByClass() {
  const startDate = yield select((state) => state.utilization.selectedRequestDates.startDate);
  const endDate = yield select((state) => state.utilization.selectedRequestDates.endDate);
  const id = yield select((state) => state.utilization.currentUser.organization_id);
  const objectId = yield select((state) => state.utilization.currentUser.current_object_id);
  const locationId = yield select((state) => state.utilization.currentUser.current_location_id);
  const regionId = yield select((state) => state.utilization.currentUser.current_region_id);
  const classFilters = yield select((state) => state.utilization.selectedClassFilters);
  const currentType = getTypeOption(
    yield select((state) => state.utilization.selectedTypeOption.name)
  );
  try {
    const response = yield call(
      axios.post,
      queryParams.apiVersion + "pages/attendance/utilization_chart/get_filters",
      {
        organization_id: id.toString(),
        location_id: locationId.toString(),
        region_id: regionId.toString(),
        object_id: objectId.toString(),
        offline: currentType.toString(),
        start_date: startDate,
        end_date: endDate,
        class_id: getIds(classFilters)
      }
    );
    yield put({ type: UPDATE_FILTERS_BY_CLASS_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: UPDATE_FILTERS_BY_CLASS_SUCCESS, error });
  }
}

function* onChangeToggle(data) {
  yield put({ type: CHANGE_TOGGLE_SUCCESS, payload: data.payload });
  yield put({ type: SET_FILTERS_DIRTY, payload: true });
}
